
import React, { useEffect, useState } from "react";
import {Tab, Tabs } from 'react-bootstrap';  
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import AdminDashboard from "./admindashboard";
import Agentinsurance from "./Agentinsurance";
import EmployeeProfile from "./employeeProfile";
import EmpAppointments from "./empAppointments";
import ViewAppointmentsByEmployer from "./viewAppointmentsByEmployer";
import EmployeeFamilyDetails from "./employeeFamilyDetails";
import EmployeeDoctorAppointment from "./employeeDoctorAppointment";
import DoctorProfile from "./doctorProfile";
import ViewDoctorAppointmentsByDoctor from "./viewDoctorAppointmentsByDoctor";
  function DoctorProfileTab() {

  const [activeTab, setActiveTab] = useState('doctor-profile');
  // const [selectedOrgcode, setSelectedOrgcode] = useState(orgcode);

  useEffect(() => {
  
  }, []);


  return (
    <div>
      <AdminDashboard />
      <br/>
              <br/>
              <br/>
      <br />


<div className="col-12 mx-xl-auto ps-xl-10">
        <div className="card card-raised">
          <div className="card-body">
            <Tabs
              id="employee-profile-tabs"
              activeKey={activeTab}
              onSelect={(tab) => setActiveTab(tab)}
              className="mb-3"
            >
              <Tab eventKey="doctor-profile" title="Doctor Profile">
              {activeTab === 'doctor-profile' && (
                <DoctorProfile/>
              )}
              </Tab>
        
          
          <Tab eventKey="doctor-appointments" title="Employee Appointments">
      {activeTab === "doctor-appointments" && (
            <ViewDoctorAppointmentsByDoctor/>
          )}
          </Tab>

            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
}
 
export default DoctorProfileTab;